import React, { Component } from "react";
import { connect } from "react-redux";

import { rehydrateState } from "state/modules/root";

class Loading extends Component {
  componentDidMount = () => {
    const { rehydrateState, isWebSurvey } = this.props;
    if (isWebSurvey) {
      return;
    }

    rehydrateState();
  };

  render = () => {
    const { groupSelected, navigation, rehydrated, sessionId } = this.props;
    const { loggedIn, trackSession } = this.props;

    if (rehydrated) {
      if (!loggedIn) {
        navigation.navigate("login");
      } else if (trackSession && !sessionId) {
        navigation.navigate("session");
      } else if (!groupSelected) {
        navigation.navigate("group");
      } else {
        navigation.navigate("start");
      }
    }

    return <></>;
  };
}

const mapDispatchToProps = {
  rehydrateState,
};

const mapStateToProps = state => {
  return {
    loggedIn: !!state.taker.id,
    trackSession: state.organization.track_taker_session,
    sessionId: state.taker.sessionId,
    groupSelected: !!state.feedback.group.id,
    isWebSurvey: !!state.survey.inviteId,
    rehydrated: state.loading.rehydrated,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Loading);
